// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"e479bb97","81":"916d63ef","141":"981388de","315":"e1224304","787":"e31e62ee","789":"3b696328","815":"67e09e5e","849":"ae75e8d7"}[chunkId] + ".chunk.js";
};